style= require('./seasons.styl')

sporty-form-field
  select((change)=this.changeSeason(e.target.value))
    option
    each s in this.seasons
      option(value=s selected=(s == season))= s.name
